export const checkNever = (value: never) => {
    return value;
};
